/**
 * The type of (redux) action which sets the low bandwidth mode flag for the
 * current conference.
 *
 * {
 *     type: SET_LOW_BANDWIDTH_MODE,
 *     lowBandwidthMode: boolean
 * }.
 */
export const SET_LOW_BANDWIDTH_MODE = 'SET_LOW_BANDWIDTH_MODE';
